// src/components/NewsBox.js
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Heading,
  Text,
  Box,
  Image,
  Divider,
  useTheme,
  Tag,
  Grid,
  GridItem,
  Button,
  VStack,
} from "@chakra-ui/react";

const NewsBox = ({
  newsBadge,
  newsSection,
  newsDate,
  newsHeader,
  newsSubHeader,
  newsImage,
  newsTags,
  direction,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleReadMoreClick = () => {
    console.log(
      "Read more clicked, navigating to /newsdetail for:",
      newsHeader
    );
    navigate("/newsdetail");
  };

  const headerFontSize = "clamp(0.7rem, 2.2vw, 0.9rem)";
  const subHeaderFontSize = "clamp(0.6rem, 2.2vw, 0.7rem)";
  const dateFontSize = "clamp(0.8rem, 2vw, 0.875rem)";
  const tagFontSize = "clamp(0.5rem, 1.8vw, 0.75rem)";

  return (
    <Box
      w="100%"
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={{ base: 3, md: 4 }}
    >
      {direction === "vertical" ? (
        // VERTICAL DIRECTION LAYOUT
        <VStack spacing={{ base: 3, md: 4 }} align="stretch">
          <Box
            borderRadius="md"
            overflow="hidden"
            w="100%"
            // height={{ base: "200px", md: "250px" }} // **REMOVED FIXED HEIGHT on container**
            display="flex"
            alignItems="center"
            justifyContent="center"
            bg={theme.colors.gray[50]} // Background for potential letterboxing if image is very narrow
          >
            <Image
              src={newsImage}
              alt={newsHeader}
              objectFit="contain" // Ensures full image is visible
              width="100%" // Image takes full width of its container
              height="auto" // **ADDED: Height adjusts to maintain aspect ratio**
              maxHeight={{ base: "200px", sm: "220px", md: "250px" }} // **ADDED: Max height for the image itself**
              // This prevents portrait images from becoming too tall
              // and also effectively limits the height for landscape images.
              // transition="0.3s ease-in-out" // Keep if desired
              // _hover={{
              //   transform: "scale(1.05)", // Scale effect might look odd with "contain" and letterboxing
              // }}
            />
          </Box>
          <VStack spacing={2} align="stretch">
            <Heading fontSize={headerFontSize} color="gray.700" noOfLines={2}>
              {newsHeader}
            </Heading>
            <Text fontSize={dateFontSize} color="blue.600">
              {newsDate}
            </Text>
          </VStack>
          <Divider />
          <Text fontSize={subHeaderFontSize} color="gray.600" noOfLines={3}>
            {newsSubHeader}
          </Text>
          <Box w="full" display="flex" justifyContent="flex-end">
            <Button
              colorScheme="blue"
              variant="outline"
              size="xs" 
              fontSize={subHeaderFontSize} 
              onClick={handleReadMoreClick}
            >
              อ่านเพิ่มเติม
            </Button>
          </Box>
          <Divider />
          <Box>
            {/*newsTags && newsTags.map((item, index) => (
              <Tag
                key={index}
                variant="solid"
                colorScheme="teal"
                mr={2}
                mb={2}
                fontSize={tagFontSize}
                fontWeight="normal"
              >
                {item}
              </Tag>
            ))*/}
          </Box>
        </VStack>
      ) : (
        // HORIZONTAL DIRECTION LAYOUT (remains largely the same as previous version)
        <Grid
          templateColumns={{ base: "1fr", md: "1fr 2fr" }}
          gap={{ base: 4, md: 5 }}
          alignItems="center"
        >
          <GridItem>
            <Box
              borderRadius="md"
              overflow="hidden"
              width="100%"
              height={{ base: "150px", md: "auto" }}
              maxH={{ md: "200px" }}
              display="flex"
              alignItems="flex-start" // <-- เปลี่ยนเป็น flex-start เพื่อจัดชิดบน
              justifyContent="center" // <-- ยังคงจัดกึ่งกลางแนวนอน
              bg={theme.colors.gray[50]}
            >
              <Image
                src={newsImage}
                alt={newsHeader}
                objectFit="contain"
                width="100%"
                maxHeight="100%"
                // transition="0.3s ease-in-out"
                // _hover={{
                //   transform: "scale(1.05)",
                // }}
              />
            </Box>
          </GridItem>
          <GridItem>
            <VStack
              spacing={{ base: 2, md: 3 }}
              align="stretch"
              h="100%"
              justifyContent="space-between"
            >
              <VStack spacing={2} align="stretch">
                <Heading
                  fontSize={headerFontSize}
                  color="gray.700"
                  noOfLines={2}
                >
                  {newsHeader}
                </Heading>
                <Text fontSize={dateFontSize} color="blue.600">
                  {newsDate}
                </Text>
                <Divider pt={{ base: 1, md: 2 }} />
                <Text
                  fontSize={subHeaderFontSize}
                  color="gray.600"
                  noOfLines={{ base: 3, md: 4 }}
                >
                  {newsSubHeader}
                </Text>
              </VStack>

              <VStack spacing={3} align="stretch" pt={2}>
                <Box w="full" display="flex" justifyContent="flex-end">
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    size="sm"
                    onClick={handleReadMoreClick}
                  >
                    อ่านเพิ่มเติม
                  </Button>
                </Box>
                <Divider />
                <Box>
                  {/*newsTags && newsTags.map((item, index) => (
                    <Tag
                        key={index}
                        variant="solid"
                        colorScheme="teal"
                        mr={2}
                        mb={2}
                        fontSize={tagFontSize}
                        fontWeight="normal"
                    >
                        {item}
                    </Tag>
                    ))*/}
                </Box>
              </VStack>
            </VStack>
          </GridItem>
        </Grid>
      )}
    </Box>
  );
};

export default NewsBox;
